<template>
    <div>
        <StopCardDialog
            :is-open="stopCardDialog"
            :stop-card-data="currentStopCard"
            @on-close="closeStopCardDialog"
        />
        <v-dialog
            :value="isOpen"
            max-width="600px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Karty stop
                    </h1>
                </v-card-title>

                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="createdStopCards"
                                :mobile-breakpoint="0"
                                :items-per-page="5"
                                :page.sync="currentPaginationPage"
                                :footer-props="{
                                    itemsPerPageText: 'Kart na stronie',
                                    showFirstLastPage: false
                                }"
                                name="createdStopCardsData"
                            >
                                <template #item.actions="{item}">
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Otwórz"
                                                    v-on="on"
                                                    @click="showStopCardDialog(item.id)"
                                                >
                                                    <v-icon color="blue">
                                                        mdi-ballot
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Otwórz</span>
                                        </v-tooltip>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Zamknij"
                        @click="onClose"
                    >
                        Zamknij
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import StopCardDialog from '@/views/Complaints/StopCards/StopCardDialog'
import tooltipDelay from '@/mixins/tooltip'
import { errorHandler } from '@/utils/errorHandler'
export default {
    name: 'CratedStopCardsDialog',
    components: {
        StopCardDialog
    },
    mixins: [
        tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        createdStopCards: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            currentPaginationPage: null,
            stopCardDialog: false,
            currentStopCard: {},
            headers: [
                {
                    text: 'Numer',
                    value: 'number',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                Promise.all([
                    this.$store.dispatch('complaints/getStopCardErrors'),
                    this.$store.dispatch('complaints/getStopCardStatuses'),
                    this.$store.dispatch('administration/getProductionDepartments'),
                    this.$store.dispatch('configurations/getProductionProcesses', {paginate: '', query: ''}),
                    this.$store.dispatch('configurations/getProducts', {paginate: '', query: '' })
                ])
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        }
    },
    methods: {
        resetPagination() {
            this.currentPaginationPage = 1
        },
        showStopCardDialog(id) {
            this.$store.dispatch('complaints/getStopCard', id)
                .then(response => {
                    this.currentStopCard = response.data
                    this.stopCardDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        closeStopCardDialog() {
            this.stopCardDialog = false
            this.currentStopCard = {}
        },
        onClose() {
            this.$emit('on-close')
            this.resetPagination()
        }
    }
}
</script>